enum OrderDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export default OrderDirection
